import React, { useState } from "react";
import { RCCButton, RCCGrid, RCCHookToast, RCCServicesApi, RCCTooltip } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import ListOfRisks from "src/pages/Risks/Panel/components/listOfRisks";
import { IRisks } from "src/pages/Risks/Panel/interface";
import { standardErrorMessages } from "src/utils/errors";
import { IPrtba010001 } from "../../interface";
import { IComponentRisks } from "./interface";

const Risks: React.FC<IComponentRisks> = ({
	risksDefaultValue,
	disabled,
	projectSelected,
	refModalRisks
}) => {

	const { translate } = useTranslation();
	const {addToast} = RCCHookToast();

	const [listData, setListData] = useState<IRisks[]>(risksDefaultValue.map((e) => e.ritbb001));

	const callcbackAddRisk = async (riskData: any) => {
		if(!riskData) return;
		try{
			await RCCServicesApi.postRequest({
				method: "Project/AssociateRisk",
				urlParameters: {
					pra010Pra002Id: projectSelected.pra002Id, 
					pra010Rib001Id: riskData
				}
			});

			setTimeout(() => {
				addToast({
					color: "green",
					description: translate("Risco associado ao projeto com sucesso"),
					title: translate("Sucesso")
				});
			}, 200);


			requestData(projectSelected.pra002Id);

		}catch(err: any){
			standardErrorMessages(err, translate("Erro ao buscar associar risco ao projeto"), addToast);
		}
	};

	const requestData = async (id: number) => {
		try{
			const {data} = await RCCServicesApi.getRequest({
				method: "Project/SelectRisksOfProject",
				urlParameters: {
					id
				}
			});
			const listRisks = data as IPrtba010001[];
			setListData(listRisks.map((e) => e.ritbb001));
		}catch(err){
			standardErrorMessages(err, translate("Erro ao carregar os riscos"), addToast);
		}
	};

	const callbackRisk = () => {
		requestData(projectSelected.pra002Id);
	};

	return (
		<>
			<RCCGrid
				container
				item
				direction="column"
				alignItems="center"
				justifyContent="center"
			>
				<RCCGrid
					container
					item
					xs={12}
				>
					<RCCGrid
						container
						item
					>
						<RCCGrid
							container
							item
							justifyContent="flex-end"
						>
							<RCCTooltip
								color="purple"
								text={translate("Novo risco")}
							>
								<RCCButton
									color="purple"
									icon={{
										name: "plus"
									}}
									layout="isRounded"
									size="md"
									onClick={() => {
										refModalRisks.current?.actionButtonAdd(callcbackAddRisk);
									}}
									disabled={disabled}
								/>
							</RCCTooltip>
						</RCCGrid>
					</RCCGrid>

					<ListOfRisks 
						layoutList="list"
						layoutListRisks="table"
						onCallbackUpdate={callbackRisk}
						onCallbackDelete={callbackRisk}
					 	data={listData}
					/>

				</RCCGrid>
			</RCCGrid>


		
		</>
	);
};

export default Risks;
